// Module
var code = "<div class=\"react-container react-zoom\"> <student-profile/> </div> ";
// Exports
module.exports = code;